import service from '@/utils/axios';

//头部栏目列表
export function colunmList(data) {
    return service({
        url: '/admin/api/v1/dxsf/dev/official/colunm/list',
        method: 'post',
        params: data
    })
}
//产品管理列表
export function productList(data) {
    return service({
        url: '/admin/api/v1/dxsf/dev/official/product/list',
        method: 'post',
        params: data
    })
}
//栏目分类列表
export function columnTypeList(data) {
    return service({
        url: '/admin/api/v1/dxsf/dev/official/columnType/list',
        method: 'post',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/topNav.js